import { consumirRotaPretendida } from '@/util/deeplink';

export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      // Devolve o parceiro ao destino que ele tentou abrir antes de logar (link único,
      // link de e-mail, sessão expirada). O `login` da query precisa sobreviver: é ele
      // que dispensa a revalidação no beforeRouteEnter da Delivery.
      const pretendida = consumirRotaPretendida();
      const destino = pretendida ? this.$router.resolve(pretendida).route : null;
      const redirect = window.sessionStorage.getItem('redirectAfterLogin');
      window.sessionStorage.removeItem('redirectAfterLogin');
      if (redirect && redirect.indexOf('/login') !== 0) {
        this.$router.push(redirect);
      } else {
        this.$router.push({
          path: destino ? destino.path : '/delivery',
          query: Object.assign({}, destino ? destino.query : {}, e || {}),
        });
      }
    }
  },
  {
    name: 'APP_ALERT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: e.color,
        text: e.text
      };
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: async function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Logout efetuado!'
      };
      try {
        await this.$root.getToken(true);
        await this.$axios.get('/logout');
      } catch (error) {
        console.error('Erro ao realizar logout:', error);
      }
      this.$root.boletos = [];
      this.$root.allPedidos = [];
      this.$root.notificacoes = [];
      this.$root.pedido = null;
      this.$root.pedido_mobile = null;
      this.$store.dispatch('resetStore');
      if (this.$route.path !== '/login') {
        this.$router.push({ path: '/login' });
      }
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Login e/ou senha inválidos!'
      };
      this.$store.dispatch('resetStore');
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Credenciais inválidas!'
      };
      this.$store.dispatch('resetStore');
      this.$router.push('/login');
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Ocorreu um erro de conexão com o servidor. Tente novamente!'
      };
    }
  },
  {
    name: 'APP_NOT_FOUND',
    // @error api response data
    callback: function (msg) {
      this.$router.push('/404');
    }
  },
  {
    name: 'APP_DIALOG_AUX',
    callback: function (msg) {
      // this.$root.dialog.aux = true;
      // this.$root.dialog.aux = false;
    }
  },
  {
    name: 'APP_UPDATE_PEDIDOS',
    callback: function (pedido) {
      const index = _.findIndex(this.$root.allPedidos, { id: pedido.id });
      const pedidos  = _.reject(this.$root.allPedidos, { id: pedido.id });
      this.$root.allPedidos = [...pedidos.slice(0, index), pedido, ...pedidos.slice(index)];
      if (this.$root.pedido && this.$root.pedido.id == pedido.id) this.$root.pedido = pedido;
      if (this.$root.pedido_mobile && this.$root.pedido_mobile.id == pedido.id) this.$root.pedido_mobile = pedido;
    },
  },
  {
    name: 'APP_UPDATE_DELIVERY',
    callback: function (delivery) {
      const deliveryAtualizado = delivery;

      let estabelecimento = null;
      if (this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.delivery && this.$root.estabelecimentoSelecionado.id == deliveryAtualizado.estabelecimento_id) {
        estabelecimento = this.$root.estabelecimentoSelecionado;
      } else {
        estabelecimento = _.find(this.$root.estabelecimentos, o => o.id == deliveryAtualizado.estabelecimento_id);
      }
      if (estabelecimento) {
        const estabelecimentoAtualizado = _.cloneDeep(estabelecimento)
        estabelecimentoAtualizado.delivery[0] = deliveryAtualizado;
        this.$root.updateEstabelecimento(estabelecimentoAtualizado);
      }

      window.getApp.$emit('UPDATE_DELIVERY_TOOLBAR', delivery.estabelecimento_id);
    },
  },
];
